import React from 'react';
import { X } from 'lucide-react';
import QRCode from './QRCode';

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  qrCodeUrl?: string;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({
  isOpen,
  onClose,
  url,
  qrCodeUrl
}) => {
  if (!isOpen) return null;

  return (
    <div className="qr-modal-overlay" onClick={onClose}>
      <div className="qr-modal" onClick={(e) => e.stopPropagation()}>
        <button className="qr-modal-close" onClick={onClose}>
          <X size={20} />
        </button>
        <h3>Scan QR Code</h3>
        <QRCode 
          url={url} 
          size={200}
          qrCodeUrl={qrCodeUrl}
        />
      </div>
    </div>
  );
};

export default QRCodeModal;
